import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const VENDORTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.VendorType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.VendorType.SapCode')
    .required()
    .minLength(1)
    .maxLength(4)
    .build(),
];

export const VENDORTYPE_CONFIG = {
  entityName: 'VendorType',
  localizationKey: 'Controlling::Entity.VendorType',
  fields: VENDORTYPE_FIELDS,
  permission: 'ControllingContract.VendorTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
